'use client';

import { getOnlyNumbers, numberFormat } from '@/app/_shared/utils/number-utils';

interface NumberInputBoxProps {
  /** input 요소의 id */
  id: string;
  /** input 요소의 label */
  label: string;
  /** input 요소의 value */
  value: string;
  onChange: (value: string) => void;
  onBlur?: (value: number) => void;
  onFocus?: () => void;
  ariaLabel: string;
}

/** 숫자만 입력 가능한 input box */
const NumberInputBox: React.FC<NumberInputBoxProps> = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  ariaLabel,
}): JSX.Element => (
  <div className="relative flex flex-grow">
    <label htmlFor={id} className="absolute left-10 top-8 text-text-neutral-sub typography-label-10-regular">
      {label}
    </label>
    <input
      className="relative w-full rounded-8 border border-line-neutral-weak3 bg-transparent px-10 pb-8 pt-22 typography-body-14-bold"
      id={id}
      aria-label={ariaLabel}
      type="tel"
      value={value}
      autoComplete="off"
      onBlur={(e) => onBlur?.(Number(getOnlyNumbers(e.target.value)))}
      onFocus={() => onFocus?.()}
      onChange={(e) => {
        onChange(numberFormat(Number(getOnlyNumbers(e.target.value))));
      }}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          e.currentTarget.blur();
        }
      }}
    />
  </div>
);

export default NumberInputBox;
